/**
 * Compact number formatting with configurable significant digits (like "1.2 K")
 */
export function formatCompactNumber(
  value: number,
  significantDigits: readonly [number, number] = [1, 3],
  locale?: string,
): string {
  const [minSig, maxSig] = significantDigits;
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    minimumSignificantDigits: minSig,
    maximumSignificantDigits: maxSig,
  }).format(value);
}
